import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
const router = new Router({
    mode: 'history',
    base: process.env.VUE_APP_PUBLIC_PATH,
    routes: [
        {
            path: '/',
            name: 'index',
            component: () => import('../pages/csp-tool/word-text/index.vue'),
        },
        {
            path: '/article',
            name: 'article',
            component: () => import('../pages/csp-tool/article/index.vue'),
        },
    ],
})
export default router
